export interface InputFormatConfig<T = string> {
  format: (text: T) => string;
  unformat: (text: string) => T;
}

export const getDefaultFormatter = (): InputFormatConfig => ({
  format: (text: string) => text,
  unformat: (text: string) => text,
});
